import React from 'react';

import { Button } from '@hpstellar/core';
import { Plus } from '@hpstellar/icons';

import useHawksearchComponent from '../useHawksearchComponent';
import useHawksearchResults from '../useHawksearchResults';

export default ({ gtmConfig }) => {
    const hawksearchResults = useHawksearchComponent();
    const { getNextPage } = useHawksearchResults();
    const { type } = hawksearchResults || {};
    const { Pagination, currentSearch } = (hawksearchResults && hawksearchResults[type]) || {};
    const { CurrentPage, NofPages } = Pagination || {};

    return (
        NofPages > CurrentPage && (
            <div className="hawksearch-pagination-section">
                <Button
                    className="hawksearch-load-more"
                    variation="secondary"
                    color="primary"
                    endIcon={<Plus size="s" />}
                    onClick={() => {
                        getNextPage({
                            ...(currentSearch || {}),
                            PageNo: CurrentPage + 1,
                        });
                    }}
                    data-gtm-category="linkClick"
                    data-gtm-id={gtmConfig && gtmConfig.loadMore && gtmConfig.loadMore.gtmId}
                    data-gtm-value="load-more"
                >
                    LOAD MORE
                </Button>
            </div>
        )
    );
};
